import React from 'react'
import { FormattedMessage } from 'react-intl'
import {
  REFI_DETAILS_HEADLINE_ARM,
  REFI_DETAILS_HEADLINE_FIX
} from 'src/constants/refinance'
import LoanName from './LoanName'
import isARM from './isARM'
import { baseProps, deltaProps } from './Shapes'

const DetailsHeadline = ({ type, years, longterm, shortterm }) => {
  let key
  if (longterm > 0 && shortterm <= 0) {
    key = 'good'
  } else if (longterm > 0) {
    key = 'long'
  } else if (shortterm <= 0) {
    key = 'short'
  } else {
    key = 'bad'
  }

  let headlineMessage
  if (key && isARM(type)) {
    headlineMessage = REFI_DETAILS_HEADLINE_ARM[key]
  } else if (key) {
    headlineMessage = REFI_DETAILS_HEADLINE_FIX[key]
  }

  return (
    <FormattedMessage
      {...headlineMessage}
      values={{
        years,
        label: <LoanName type={type} years={years} />
      }}
    />
  )
}

DetailsHeadline.propTypes = {
  ...baseProps,
  ...deltaProps
}

export default DetailsHeadline
